import React from 'react';





const FooterLanding = ({ showRedes = true }) => {

    const fecha = new Date();
    const year = fecha.getFullYear();

    return (

        <section className='flex flex-col justify-center py-8 md:py-12 gap-8 bgNeg900 w-full'>
            <div className='flex justify-center items-center flex-row gap-5 text-xs mt-3'>

                <img
                    src="https://ganaenergia.com/img/logo-blanco.svg"
                    width={150}
                    height={31}
                    alt="gana energia"
                    className="w-32 md:w-44"
                />

                <div>
                    <p className='text-white'> El ahorro sin líos.</p>
                    <p className='text-white'>Luz y gas a precios ajustados.</p>
                </div>

            </div>

            <div className='flex flex-col gap-3 items-center'>

                <div className="inline w-full p-2 text-white text-[10px] justify-center text-center">

                    <a className="px-3 leading-relaxed" href="https://ganaenergia.com/aviso-legal">Aviso legal</a>
                    <a className="px-3 leading-relaxed" href="https://ganaenergia.com/politica-de-cookies">Política de Cookies</a>
                    <a className="px-3 leading-relaxed" href="https://ganaenergia.com/canal-codigo-etico">Canal ético</a>
                    <a className="px-3 leading-relaxed" href="https://ganaenergia.com/politica-de-privacidad">Política de Privacidad</a>
                    <a className="px-3 leading-relaxed" href="https://ganaenergia.com/politica-de-redes-sociales">Política de Redes Sociales</a>
                    <a className="px-3 leading-relaxed" href="https://ganaenergia.com/condiciones-uso-tpv-virtual"> Condiciones uso TPV Virtual</a>

                </div>

                <div>
                    <p className="font-bold text-white text-[10px]">{year} Gana Energía. Todos los derechos reservados.</p>
                </div>

            </div>

        </section>
    )
}

export default FooterLanding;
